import { Send as SendIcon } from "@mui/icons-material";
import { CloseMenuType } from "atoms/SimpleMenu";
import ButtonOrMenuItemWithDialog from "organisms/ButtonOrMenuItemWithDialog";
import { InvoiceRecordType } from "pages/Booking/Booking.types";
import { GeneratedDocumentRecordType } from "pages/DocumentTemplate/DocumentTemplate.types";
import { EventRecordType } from "pages/Event/Event.types";
import { EmailContactInfoTypeEnum } from "pages/SharedRecords.types";

import SendEmailDialogContent, { TEMPLATE_TYPES } from "./SendEmailDialog/SendEmailDialogContent";

type SendInvoicesDialogButtonOrMenuItemPropsType = {
  invoices: InvoiceRecordType[];
  event?: EventRecordType;
  onSuccess?: () => void;
  closeMenu?: CloseMenuType;
  disabled?: boolean;
  tooltipTitle?: string;
  onClose?: () => void;
  generatedDocuments?: GeneratedDocumentRecordType[];
};

export default function SendInvoicesDialogButtonOrMenuItem(props: SendInvoicesDialogButtonOrMenuItemPropsType) {
  const { event, invoices, disabled, tooltipTitle, onClose, onSuccess, closeMenu, generatedDocuments } = props;

  const getGeneratedDocument = (id: number, resource: string) => {
    if (!generatedDocuments) {
      return undefined;
    }
    const matchingFile = generatedDocuments.find(
      (generatedDocument) => generatedDocument.related_id === id && resource === generatedDocument.related_resource,
    );
    return matchingFile ? matchingFile.id : undefined;
  };

  return (
    <ButtonOrMenuItemWithDialog
      label="ra.action.send"
      closeMenu={closeMenu}
      onClose={onClose}
      buttonIcon={<SendIcon />}
      isDisabled={disabled || invoices.length === 0}
      tooltipTitle={tooltipTitle}
      maxWidth="lg"
      fullWidth
    >
      {(closeDialog) => (
        <SendEmailDialogContent
          templateType={TEMPLATE_TYPES.INVOICE}
          event={event}
          recipients={invoices.map((invoice) => {
            return {
              related_resource: "invoice",
              related_id: invoice.id,
              contact_info_type: EmailContactInfoTypeEnum.INVOICE,
              generated_document: getGeneratedDocument(invoice.id, "invoice"),
              file: invoice.pdf ? invoice.pdf.id : undefined,
            };
          })}
          onSuccess={onSuccess}
          closeDialog={closeDialog}
          withGeneratedDocument
        />
      )}
    </ButtonOrMenuItemWithDialog>
  );
}
